export default __webpack_public_path__ + "static/media/nav-logo2.ae68551b.ico";